// import { create } from 'zustand';
// import { Pagination } from '../../interfaces';
// import { transformCheckDataToFilter } from '../../util/transform-checkdata-to-filter';

// // Definimos una interfaz para los filtros
// export interface FilterRaw {
//     nameTable: string;
//     // Cuando hay que usar la relación de una relación
//     nameTable2?: string;
//     nameColumn: string;
//     label: string;
//     title: string;
//     value: any;
//     relationType?: 'is' | 'every' | 'some' | 'none'; // Agregado campo relationType
//     relationType2?: 'is' | 'every' | 'some' | 'none'; // Agregado campo relationType 
// }



// // Combinamos los estados de filtros y paginación en un solo estado
// interface PaginationAndFilterRawState {
//     pagination: Pagination;
//     filtersRaw: FilterRaw[];
// }

// // Combinamos las acciones de filtros y paginación en un solo conjunto de acciones
// interface PaginationAndFilterRawActions {
//     addFilterRaw: (filter: FilterRaw) => void;
//     addFilterRawExclusive: (filter: FilterRaw) => void;
//     removeFilterRaw: (nameTable: string, nameColumn: string, title: any) => void;
//     removeFilterRawMassive: (filtersRawToRemove: FilterRaw[]) => void;
//     resetFilterRaws: () => void;

//     setPagination: (pagination: Pagination) => void;
// }

// export const usePaginationStore = create<PaginationAndFilterRawState & PaginationAndFilterRawActions>((set) => ({
//     // Valores iniciales para paginación
//     pagination: undefined,
//     filtersRaw: [],

//     // Acción para establecer cualquier parte del estado de paginación
//     setPagination: (pagination: Pagination) => set((state) => {
//         console.log("que es pagination", pagination)
//         return {
//             pagination: { ...state.pagination, ...pagination }
//         }
//     }),

//     addFilterRaw: (filter) => set((state) => {
//         const updatedFiltersRaw = [...state.filtersRaw, filter];
//         const updatedFilters = transformCheckDataToFilter(updatedFiltersRaw);
//         return {
//             filtersRaw: updatedFiltersRaw,
//             pagination: { ...state.pagination, filters: updatedFilters, page: 0 },
//         };
//     }),
//     addFilterRawExclusive: (filter) => set((state) => {
//         const updatedFiltersRaw = [...state.filtersRaw.filter(f => !(f.nameTable === filter.nameTable && f.nameColumn === filter.nameColumn)), filter];
//         const updatedFilters = transformCheckDataToFilter(updatedFiltersRaw);
//         return {
//             filtersRaw: updatedFiltersRaw,
//             pagination: { ...state.pagination, filters: updatedFilters, page: 0 },
//         };
//     }),
//     removeFilterRaw: (nameTable, nameColumn, title) => set((state) => {
//         const updatedFiltersRaw = state.filtersRaw.filter(f => !(f.nameTable === nameTable && f.nameColumn === nameColumn && f.title === title));
//         const updatedFilters = transformCheckDataToFilter(updatedFiltersRaw);
//         return {
//             filtersRaw: updatedFiltersRaw,
//             pagination: { ...state.pagination, filters: updatedFilters, page: 0 },
//         };
//     }),
//     removeFilterRawMassive: (filtersRawToRemove) => set((state) => {
//         const updatedFiltersRaw = state.filtersRaw.filter(f =>
//             !filtersRawToRemove.some(fr =>
//                 f.nameTable === fr.nameTable &&
//                 f.nameColumn === fr.nameColumn &&
//                 f.title === fr.title
//             )
//         );
//         const updatedFilters = transformCheckDataToFilter(updatedFiltersRaw);
//         return {
//             filtersRaw: updatedFiltersRaw,
//             pagination: { ...state.pagination, filters: updatedFilters, page: 0 },
//         };
//     }),
//     resetFilterRaws: () => set((state) => {
//         return {
//             filtersRaw: [],
//             pagination: { ...state.pagination, filters: {}, page: 0 },
//         };
//     }),




// }));

// import { create } from "zustand";
// import { Pagination } from "../../interfaces";
// import { transformCheckDataToFilter } from "../../util/transform-checkdata-to-filter";

// // Definimos una interfaz para los filtros
// export interface FilterRaw {
//   nameTable: string;
//   nameTable2?: string;
//   nameColumn: string;
//   label: string;
//   title: string;
//   value: any;
//   relationType?: "is" | "every" | "some" | "none";
//   relationType2?: "is" | "every" | "some" | "none";
// }

// // Combinamos los estados de filtros y paginación en un solo estado
// interface PaginationAndFilterRawState {
//   pagination: Pagination | undefined;
//   filtersRaw: FilterRaw[];
// }

// // Combinamos las acciones de filtros y paginación en un solo conjunto de acciones
// interface PaginationAndFilterRawActions {
//   addFilterRaw: (filter: FilterRaw) => void;
//   addFilterRawExclusive: (filter: FilterRaw) => void;
//   removeFilterRaw: (nameTable: string, nameColumn: string, title: any) => void;
//   removeFilterRawMassive: (filtersRawToRemove: FilterRaw[]) => void;
//   resetFilterRaws: () => void;
//   setPagination: (pagination: Pagination) => void;
// }

// export const usePaginationStore = create<
//   PaginationAndFilterRawState & PaginationAndFilterRawActions
// >((set) => ({
//   pagination: undefined,
//   filtersRaw: [],

//   setPagination: (pagination: Pagination) =>
//     set((state) => ({
//       pagination: { ...state.pagination, ...pagination },
//     })),

//   /**
//    * addFilterRaw:
//    * - Añade el filtro a filtersRaw.
//    * - startDate / endDate => se ponen en pagination.startDate / endDate
//    * - El resto => se guardan en pagination.filters (por transformCheckDataToFilter)
//    */
//   addFilterRaw: (filter) =>
//     set((state) => {
//       // 1) Actualizamos la lista de filtros
//       const updatedFiltersRaw = [...state.filtersRaw, filter];

//       // 2) Tomamos sólo los que NO son start/end, para generarlos en "filters"
//       const filtersWithoutStartEnd = updatedFiltersRaw.filter(
//         (f) => f.nameColumn !== "startDate" && f.nameColumn !== "endDate"
//       );
//       // 3) Generamos el objeto filters con transformCheckDataToFilter
//       const updatedFilters = transformCheckDataToFilter(filtersWithoutStartEnd);

//       // 4) Creamos la paginación base con esos filters
//       let newPagination: Pagination = {
//         ...state.pagination,
//         filters: updatedFilters,
//         page: 0,
//       };

//       // 5) Si es startDate o endDate, lo ponemos fuera de filters
//       if (filter.nameColumn === "startDate") {
//         newPagination.startDate = filter.value;
//       } else if (filter.nameColumn === "endDate") {
//         newPagination.endDate = filter.value;
//       }

//       return {
//         filtersRaw: updatedFiltersRaw,
//         pagination: newPagination,
//       };
//     }),

//   /**
//    * addFilterRawExclusive:
//    * - Elimina de filtersRaw los que tengan (nameTable+nameColumn) igual,
//    *   luego añade el nuevo
//    * - start/end => se ponen en pagination.startDate/endDate
//    * - El resto => van a pagination.filters
//    */
//   addFilterRawExclusive: (filter) =>
//     set((state) => {
//       // 1) Filtramos los que NO coincidan con nameTable+nameColumn
//       const filtered = state.filtersRaw.filter(
//         (f) => !(f.nameTable === filter.nameTable && f.nameColumn === filter.nameColumn)
//       );
//       // 2) Añadimos el nuevo
//       const updatedFiltersRaw = [...filtered, filter];

//       // 3) Los que no sean start/end van al transform
//       const filtersWithoutStartEnd = updatedFiltersRaw.filter(
//         (f) => f.nameColumn !== "startDate" && f.nameColumn !== "endDate"
//       );
//       const updatedFilters = transformCheckDataToFilter(filtersWithoutStartEnd);

//       // 4) Creamos la nueva paginación
//       let newPagination: Pagination = {
//         ...state.pagination,
//         filters: updatedFilters,
//         page: 0,
//       };

//       // 5) Aplano start/end
//       if (filter.nameColumn === "startDate") {
//         newPagination.startDate = filter.value;
//       } else if (filter.nameColumn === "endDate") {
//         newPagination.endDate = filter.value;
//       }

//       return {
//         filtersRaw: updatedFiltersRaw,
//         pagination: newPagination,
//       };
//     }),

//   /**
//    * removeFilterRaw:
//    * - Borra uno en filtersRaw
//    * - Regenera pagination.filters sin start/end
//    * - Si nameColumn = startDate/endDate => lo quitamos de la raíz
//    */
//   removeFilterRaw: (nameTable, nameColumn, title) =>
//     set((state) => {
//       // 1) Filtramos
//       const updatedFiltersRaw = state.filtersRaw.filter(
//         (f) => !(f.nameTable === nameTable && f.nameColumn === nameColumn && f.title === title)
//       );

//       // 2) Rehacemos filters sin los start/end
//       const filtersWithoutStartEnd = updatedFiltersRaw.filter(
//         (f) => f.nameColumn !== "startDate" && f.nameColumn !== "endDate"
//       );
//       const updatedFilters = transformCheckDataToFilter(filtersWithoutStartEnd);

//       // 3) Nueva paginación
//       let newPagination: Pagination = {
//         ...state.pagination,
//         filters: updatedFilters,
//         page: 0,
//       };

//       // 4) Si quitas startDate/endDate => borramos de la raíz
//       if (nameColumn === "startDate") {
//         delete newPagination.startDate;
//       } else if (nameColumn === "endDate") {
//         delete newPagination.endDate;
//       }

//       return {
//         filtersRaw: updatedFiltersRaw,
//         pagination: newPagination,
//       };
//     }),

//   /**
//    * removeFilterRawMassive:
//    * - Lo mismo, pero para varios
//    */
//   removeFilterRawMassive: (filtersRawToRemove) =>
//     set((state) => {
//       // 1) Filtramos en base a la lista
//       const updatedFiltersRaw = state.filtersRaw.filter((f) => {
//         return !filtersRawToRemove.some(
//           (rem) =>
//             rem.nameTable === f.nameTable &&
//             rem.nameColumn === f.nameColumn &&
//             rem.title === f.title
//         );
//       });

//       // 2) Generamos filters sin start/end
//       const filtersWithoutStartEnd = updatedFiltersRaw.filter(
//         (f) => f.nameColumn !== "startDate" && f.nameColumn !== "endDate"
//       );
//       const updatedFilters = transformCheckDataToFilter(filtersWithoutStartEnd);

//       // 3) Nueva paginación
//       let newPagination: Pagination = {
//         ...state.pagination,
//         filters: updatedFilters,
//         page: 0,
//       };

//       // 4) Si algún removed era start/end => lo quitamos de la raíz
//       filtersRawToRemove.forEach((rem) => {
//         if (rem.nameColumn === "startDate") {
//           delete newPagination.startDate;
//         } else if (rem.nameColumn === "endDate") {
//           delete newPagination.endDate;
//         }
//       });

//       return {
//         filtersRaw: updatedFiltersRaw,
//         pagination: newPagination,
//       };
//     }),

//   /**
//    * resetFilterRaws:
//    * - Limpia filtersRaw y pagination.filters,
//    * - Quita startDate/endDate
//    */
//   resetFilterRaws: () =>
//     set((state) => {
//       const newPagination = {
//         ...state.pagination,
//         filters: {},
//         page: 0,
//       };
//       delete newPagination.startDate;
//       delete newPagination.endDate;

//       return {
//         filtersRaw: [],
//         pagination: newPagination,
//       };
//     }),
// }));



import { create } from "zustand";
import { Pagination } from "../../interfaces";
import { transformCheckDataToFilter } from "../../util/transform-checkdata-to-filter";

// Interfaz de cada filtro
export interface FilterRaw {
  nameTable: string;
  nameTable2?: string;
  nameColumn: string;
  label: string;
  title: string; 
  value: any;     
  relationType?: "is" | "every" | "some" | "none";
  relationType2?: "is" | "every" | "some" | "none";
}

// Estado global
interface PaginationAndFilterRawState {
  pagination: Pagination | undefined;
  filtersRaw: FilterRaw[];
}

// Acciones
interface PaginationAndFilterRawActions {
  addFilterRaw: (filter: FilterRaw) => void;
  addFilterRawExclusive: (filter: FilterRaw) => void;
  removeFilterRaw: (nameTable: string, nameColumn: string, title: any) => void;
  removeFilterRawMassive: (filtersRawToRemove: FilterRaw[]) => void;
  resetFilterRaws: () => void;
  setPagination: (pagination: Pagination) => void;
}

export const usePaginationStore = create<
  PaginationAndFilterRawState & PaginationAndFilterRawActions
>((set) => ({
  pagination: undefined,
  filtersRaw: [],

  setPagination: (pagination: Pagination) =>
    set((state) => ({
      pagination: { ...state.pagination, ...pagination },
    })),

  /**
   * addFilterRaw
   *  - Si nameColumn = 'startDate' o 'endDate', se guardan en pagination.startDate/endDate
   *  - El resto en pagination.filters.
   *  - No elimina posibles anteriores (para sobreescribir, usa addFilterRawExclusive).
   */
  addFilterRaw: (filter) =>
    set((state) => {
      const updatedFiltersRaw = [...state.filtersRaw, filter];

      // Excluir start/end del transform
      const filtersWithoutStartEnd = updatedFiltersRaw.filter(
        (f) => f.nameColumn !== "startDate" && f.nameColumn !== "endDate"
      );
      const updatedFilters = transformCheckDataToFilter(filtersWithoutStartEnd);

      let newPagination: Pagination = {
        ...state.pagination,
        filters: updatedFilters,
        page: 0,
      };

      // Aplanar startDate / endDate
      if (filter.nameColumn === "startDate") {
        newPagination.startDate = filter.value;
      }
      if (filter.nameColumn === "endDate") {
        newPagination.endDate = filter.value;
      }

      return {
        filtersRaw: updatedFiltersRaw,
        pagination: newPagination,
      };
    }),

  /**
   * addFilterRawExclusive
   *  - Primero elimina de filtersRaw cualquier filter con la misma nameTable+nameColumn
   *  - Luego añade este (así sobreescribe).
   */
  addFilterRawExclusive: (filter) =>
    set((state) => {
      // 1) Filtramos los antiguos con misma nameTable + nameColumn
      const filtered = state.filtersRaw.filter(
        (f) => !(f.nameTable === filter.nameTable && f.nameColumn === filter.nameColumn)
      );
      const updatedFiltersRaw = [...filtered, filter];

      // 2) Excluir start/end y generar filters
      const filtersWithoutStartEnd = updatedFiltersRaw.filter(
        (f) => f.nameColumn !== "startDate" && f.nameColumn !== "endDate"
      );
      const updatedFilters = transformCheckDataToFilter(filtersWithoutStartEnd);

      // 3) Crear nueva paginación
      let newPagination: Pagination = {
        ...state.pagination,
        filters: updatedFilters,
        page: 0,
      };

      // 4) Aplanar si es startDate/endDate
      if (filter.nameColumn === "startDate") {
        newPagination.startDate = filter.value;
      }
      if (filter.nameColumn === "endDate") {
        newPagination.endDate = filter.value;
      }

      return {
        filtersRaw: updatedFiltersRaw,
        pagination: newPagination,
      };
    }),

  /**
   * removeFilterRaw
   *  - Elimina 1 filterRaw
   *  - Regenera pagination.filters sin start/end
   *  - Quita pagination.startDate/endDate si corresponde
   */
  removeFilterRaw: (nameTable, nameColumn, title) =>
    set((state) => {
      const updatedFiltersRaw = state.filtersRaw.filter(
        (f) => !(f.nameTable === nameTable && f.nameColumn === nameColumn && f.title === title)
      );

      const filtersWithoutStartEnd = updatedFiltersRaw.filter(
        (f) => f.nameColumn !== "startDate" && f.nameColumn !== "endDate"
      );
      const updatedFilters = transformCheckDataToFilter(filtersWithoutStartEnd);

      let newPagination: Pagination = {
        ...state.pagination,
        filters: updatedFilters,
        page: 0,
      };

      // Si era startDate/endDate => borramos
      if (nameColumn === "startDate") {
        delete newPagination.startDate;
      }
      if (nameColumn === "endDate") {
        delete newPagination.endDate;
      }

      return {
        filtersRaw: updatedFiltersRaw,
        pagination: newPagination,
      };
    }),

  /**
   * removeFilterRawMassive
   *  - Lo mismo, pero para varios.
   */
  removeFilterRawMassive: (filtersRawToRemove) =>
    set((state) => {
      const updatedFiltersRaw = state.filtersRaw.filter((f) => {
        return !filtersRawToRemove.some(
          (rem) =>
            rem.nameTable === f.nameTable &&
            rem.nameColumn === f.nameColumn &&
            rem.title === f.title
        );
      });

      const filtersWithoutStartEnd = updatedFiltersRaw.filter(
        (f) => f.nameColumn !== "startDate" && f.nameColumn !== "endDate"
      );
      const updatedFilters = transformCheckDataToFilter(filtersWithoutStartEnd);

      let newPagination: Pagination = {
        ...state.pagination,
        filters: updatedFilters,
        page: 0,
      };

      filtersRawToRemove.forEach((rem) => {
        if (rem.nameColumn === "startDate") {
          delete newPagination.startDate;
        }
        if (rem.nameColumn === "endDate") {
          delete newPagination.endDate;
        }
      });

      return {
        filtersRaw: updatedFiltersRaw,
        pagination: newPagination,
      };
    }),

  resetFilterRaws: () =>
    set((state) => {
      const newPagination = {
        ...state.pagination,
        filters: {},
        page: 0,
      };
      delete newPagination.startDate;
      delete newPagination.endDate;

      return {
        filtersRaw: [],
        pagination: newPagination,
      };
    }),
}));
